import React from "react";
import Lottie from "react-lottie";
import typingLottie from "./lottie/typing.json";

export default function IsTyping({ color, size }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: typingLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions}  isStopped={false} isPaused={false} />;
}
